// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  firebaseConfig:{
    apiKey: "AIzaSyAJe22mpIqgHjIPOTg8nf4XHyje-ntEXc4",

    authDomain: "morlakos-juego.firebaseapp.com",
  
    projectId: "morlakos-juego",
  
    storageBucket: "morlakos-juego.appspot.com",
  
    messagingSenderId: "949975883584",
  
    appId: "1:949975883584:web:e190733c9a191e3059e4a5",
  
    measurementId: "G-Z55QR039XW"
  
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
